import React, { useState } from 'react'
import "../styles/About.css"
import { useLanguage } from "../contexts/LanguageContext";

const About = () => {
  const [expanded, setExpanded] = useState(false);
  const { language } = useLanguage();

  const content = {
    historyTitle: {
      english: "Our History & Legacy",
      tamil: "எங்கள் வரலாறு மற்றும் மரபு"
    },
    historyDescription: {
      english: "The Bharatiya Janata Party is the world's largest political party. Founded in 1980, it champions the cause of Indian culture, nationalism, and integral humanism. From a humble beginning of 2 seats in 1984 to leading the nation today, our journey is one of dedication and sacrifice.",
      tamil: "பாரதிய ஜனதா கட்சி உலகின் மிகப்பெரிய அரசியல் கட்சியாகும். 1980-ல் நிறுவப்பட்ட இக்கட்சி, இந்திய கலாச்சாரம், தேசியவாதம் மற்றும் ஒருங்கிணைந்த மனிதநேயம் ஆகியவற்றிற்காகப் போராடுகிறது. 1984-ல் 2 இருக்கைகளுடன் தொடங்கி இன்று நாட்டை வழிநடத்தும் வரை, எங்கள் பயணம் அர்ப்பணிப்பு மற்றும் தியாகத்தின் கதையாகும்."
    },
    profileTitle: {
      english: "R. Sudha RadhaKrishnan",
      tamil: "ஆர். சுதா ராதாகிருஷ்ணன்"
    },
    ideologyTitle: {
      english: "Our Ideology",
      tamil: "எங்கள் சித்தாந்தம்"
    },
    leadershipTitle: {
      english: "Visionary Leadership",
      tamil: "தொலைநோக்கு தலைமை"
    },
    journeyTitle: {
      english: "Political Journey",
      tamil: "அரசியல் பயணம்"
    },
    achievementsTitle: {
      english: "Key Achievements",
      tamil: "முக்கிய சாதனைகள்"
    },
    readMore: {
      english: "Read More",
      tamil: "மேலும் வாசிக்க"
    },
    readLess: {
      english: "Read Less",
      tamil: "குறைவாக வாசிக்க"
    }
  };

  const stats = [
    {
      value: "1980",
      label: {
        english: "Founded",
        tamil: "நிறுவப்பட்டது"
      }
    },
    {
      value: "180M+",
      label: {
        english: "Members",
        tamil: "உறுப்பினர்கள்"
      }
    },
    {
      value: "303",
      label: {
        english: "Lok Sabha Seats (2019)",
        tamil: "மக்களவை இடங்கள் (2019)"
      }
    },
    {
      value: "18+",
      label: {
        english: "States Governed",
        tamil: "மாநிலங்கள் ஆட்சி"
      }
    }
  ];

  const highlightContent = {
    english: [
      {
        heading: "Opinion About BJP",
        content: [
          "The BJP is steadily growing and gaining strong public support. The party is implementing several welfare schemes for minorities, small-scale workers, women, and other sections of society. Through these initiatives, BJP has earned the trust of the people and is playing a significant role in India's progress.",
          "The reforms, development projects, and governance initiatives undertaken by the BJP are contributing greatly to national growth and social development."
        ]
      },
      {
        heading: "Personal Life and Education",
        content: [
          "Native Place: Tiruchengode.",
          "School: SDA Matriculation School.",
          "Classes 6 to 10: Government Higher Secondary School, Tiruchengode.",
          "My goal was to study medicine and pursue a career in the medical field. However, my family suddenly decided to arrange my marriage.",
          "While studying Computer Science in the 11th standard, I appeared for the quarterly examinations. After completing the quarterly exams, my engagement took place. Before the half-yearly examinations, I got married in February 1999.",
          "Even after marriage, I did not lose my interest in learning. I pursued courses such as Spoken English, Hindi, Typing, and Tally, along with other computer-related subjects. These courses significantly improved my knowledge and skills."
        ]
      },
      {
        heading: "Business Journey",
        content: [
          "With the intention of starting my own business, I began learning about the gold and silver trade by assisting at my husband's shop. This gradually increased my interest in the jewellery and pawn broking (bankers) business.",
          "Later, I started maintaining weekly and monthly accounts and successfully built a customer base of more than 1,000 clients.",
          "Eventually, I started my own business under the name 'Sanjay Bankers' and continued to expand and improve it successfully."
        ]
      },
      {
        heading: "Women Empowerment, Marketing & Social Service",
        content: [
          "During this phase of my life, I gained a wide circle of women friends. Through this association, I became a women's group leader and began guiding and teaching them step by step. I was continuously involved in motivating and supporting other women towards personal and professional development. Later, we started a saree business and entered the Herbalife sector. This marked my first step into the field of marketing. Initially, I focused on achieving nutrition-based health results for myself and my family. This helped me overcome the guilt of not becoming a doctor, as I was able to counsel others, provide health guidance, and conduct basic health checkups. Through this initiative, I have supported and guided more than one lakh people. Within my team alone, I managed up to 15 centers. Following this, I became actively involved in social service, as I am naturally a helping-minded person. I support people in need without expecting anything in return. Although my family initially did not permit me to engage in such activities, I continued helping and supporting people in every way possible. During this journey, BJP extended strong support to the work I was doing. I was particularly inspired by the work of Annamalai. With proper guidance, leadership, and empowerment, I realized that I could contribute much more to society. This realization motivated me to become an active part of the Bharatiya Janata Party."
        ]
      }
    ],
    tamil: [
      {
        heading: "BJP குறித்து கருத்து",
        content: [
          "BJP-யின் வளர்ச்சி நாளுக்கு நாள் அதிகரித்து வருகிறது. மக்களிடையே வலுவான ஆதரவைப் பெற்றுள்ள இக்கட்சி, சிறுபான்மையினர், குறுந்தொழிலாளர்கள், பெண்கள் உள்ளிட்ட அனைத்து சமூகங்களின் நலனுக்காக பல்வேறு திட்டங்களை செயல்படுத்தி வருகிறது. இதன் மூலம் மக்களின் நம்பிக்கையைப் பெற்ற BJP, இந்தியாவின் முன்னேற்றத்திற்கு முக்கிய பங்காற்றி வருகிறது.",
          "BJP மேற்கொண்டு வரும் சீர்திருத்தங்கள், வளர்ச்சி திட்டங்கள் மற்றும் நிர்வாக நடவடிக்கைகள் நாட்டின் வளர்ச்சிக்கும் சமூக முன்னேற்றத்திற்கும் வழிவகுக்கின்றன."
        ]
      },
      {
        heading: "தனிப்பட்ட வாழ்க்கை மற்றும் கல்வி",
        content: [
          "பிறந்த ஊர்: திருச்செங்கோடு.",
          "பள்ளி: SDA மெட்ரிகுலேஷன் பள்ளி.",
          "6 முதல் 10ஆம் வகுப்பு வரை: அரசு மேல்நிலைப் பள்ளி, திருச்செங்கோடு.",
          "எனது இலக்கு மருத்துவராகப் படித்து மருத்துவத் துறையில் பணியாற்ற வேண்டும் என்பதாக இருந்தது. ஆனால் குடும்பத்தினர் திடீரென எனது திருமணத்தை முடிவு செய்தனர்.",
          "11ஆம் வகுப்பில் கணினி அறிவியல் படித்து வந்தபோது காலாண்டுத் தேர்வை எழுதினேன். அந்தத் தேர்வு முடிந்த பின்னர் நிச்சயதார்த்தம் நடைபெற்றது. அரையாண்டுத் தேர்வுக்கு முன்பே, 1999ஆம் ஆண்டு பிப்ரவரி மாதம் எனக்கு திருமணம் நடைபெற்றது.",
          "திருமணத்திற்குப் பிறகும் கற்றல் மீதான ஆர்வம் குறையவில்லை. அதனால் Spoken English, Hindi, Typing, Tally போன்ற கணினி சார்ந்த பல பாடநெறிகளை கற்றுக்கொண்டேன். இவை அனைத்தும் என் அறிவையும் திறமைகளையும் மேம்படுத்தின."
        ]
      },
      {
        heading: "தொழில் வாழ்க்கை",
        content: [
          "சுயதொழில் செய்ய வேண்டும் என்ற எண்ணத்துடன், என் கணவரின் கடையில் அமர்ந்து தங்கம் மற்றும் வெள்ளி வியாபாரம் குறித்து கற்றுக்கொள்ளத் தொடங்கினேன். அதன்மூலம் அந்தத் தொழிலில் எனக்கு அதிக ஆர்வம் ஏற்பட்டது.",
          "பின்னர் நகை அடகு (Bankers) தொழிலில் ஈடுபட்டு, வாராந்திர மற்றும் மாதாந்திர கணக்குகளை தயாரிக்கத் தொடங்கினேன். இதன் மூலம் 1000-க்கும் மேற்பட்ட வாடிக்கையாளர்களைப் பெற்றேன்.",
          "அதனைத் தொடர்ந்து 'Sanjay Bankers' என்ற பெயரில் எனது சொந்த தொழிலைத் தொடங்கி, அதை மேலும் வளர்ச்சியடைந்து முன்னேற்றம் காணச் செய்தேன்."
        ]
      },
      {
        heading: "பெண்கள் முன்னேற்றம், மார்க்கெட்டிங் & சமூக சேவை",
        content: [
          "இந்த காலகட்டத்தில் பெண்கள் மத்தியில் எனக்கு பெரிய நட்பு வட்டம் உருவானது. இதன் மூலம் நான் பெண்கள் குழுத் தலைவியாக செயல்பட்டு, அவர்களுக்கு படிப்படியாக வழிகாட்டலும் பயிற்சியும் அளிக்கத் தொடங்கினேன். தொடர்ந்து பிற பெண்களின் வளர்ச்சிக்கும் முன்னேற்றத்திற்கும் ஊக்கமளித்து வந்தேன். பின்னர் நாங்கள் சேலை வியாபாரத்தைத் தொடங்கி Herbalife துறையிலும் இணைந்தோம். இதுவே எனது மார்க்கெட்டிங் வாழ்க்கையின் முதல் படியாக அமைந்தது. ஆரம்பத்தில் எனக்கும் என் குடும்பத்தினருக்கும் ஊட்டச்சத்து சார்ந்த நல்ல மாற்றங்களை ஏற்படுத்தினேன். இதன் மூலம் மருத்துவராக முடியவில்லை என்ற மனக்குறை நீங்கியது, ஏனெனில் பிறருக்கு ஆலோசனைகள் வழங்கி, உடல்நல வழிகாட்டலும், சுகாதார பரிசோதனைகளும் செய்ய முடிந்தது. இந்த முயற்சியின் மூலம் ஒரு இலட்சத்திற்கும் அதிகமான மக்களுக்கு நான் உதவி செய்துள்ளேன். என் குழுவில் மட்டும் 15 மையங்கள் வரை நான் நிர்வகித்து வந்தேன். இதனைத் தொடர்ந்து சமூக சேவைகளிலும் ஈடுபடத் தொடங்கினேன். பிறருக்கு உதவ வேண்டும் என்ற எண்ணம் இயல்பாகவே எனக்கு இருந்ததால், எந்த எதிர்பார்ப்பும் இன்றி தேவைப்படுபவர்களுக்கு உதவி செய்து வந்தேன். ஆரம்பத்தில் என் குடும்பம் இதற்கு அனுமதி அளிக்கவில்லை என்றாலும், என்னால் இயன்ற அளவில் தொடர்ந்து சமூக சேவைகளை மேற்கொண்டேன். இந்த பயணத்தில், நான் செய்து வந்த பணிகளுக்கு BJP பெரும் ஆதரவை வழங்கியது. குறிப்பாக அண்ணாமலையின் செயல்பாடுகள் எனக்கு மிகுந்த ஊக்கத்தை அளித்தன. சரியான வழிகாட்டலும் அதிகாரமும் கிடைத்தால் இன்னும் அதிகமாகச் செய்ய முடியும் என்பதை உணர்ந்து, அதன் விளைவாக நான் பாரதிய ஜனதா கட்சியின் ஒரு பகுதியாக இணைந்தேன்."
        ]
      }
    ]
  };

  const ideologyData = [
    {
      title: {
        english: "Integral Humanism",
        tamil: "ஒருங்கிணைந்த மனிதநேயம்"
      },
      desc: {
        english: "A philosophy that places the human being at the center of development, balancing material and spiritual needs.",
        tamil: "மனிதனை மையமாக வைத்து, பொருளாதார மற்றும் ஆன்மீக தேவைகளை சமநிலைப்படுத்தும் ஒரு தத்துவம்."
      }
    },
    {
      title: {
        english: "Cultural Nationalism",
        tamil: "கலாசார தேசியம்"
      },
      desc: {
        english: "Belief that India is a cultural nation, and our unity lies in our shared heritage and values.",
        tamil: "இந்தியா ஒரு கலாசார நாடு என்ற நம்பிக்கை, நமது ஒற்றுமை நமது பகிரப்பட்ட பாரம்பரியத்திலும் மதிப்புகளிலும் உள்ளது."
      }
    },
    {
      title: {
        english: "Development Driven",
        tamil: "வளர்ச்சி சார்ந்த"
      },
      desc: {
        english: "Governance focused on infrastructure, technology, and economic empowerment for all citizens.",
        tamil: "அனைத்து குடிமக்களுக்கும் உள்கட்டமைப்பு, தொழில்நுட்பம் மற்றும் பொருளாதார அதிகாரமளிப்பில் கவனம் செலுத்தும் ஆட்சி."
      }
    }
  ];

  const leaders = [
    {
      name: {
        english: "Pt. Deendayal Upadhyaya",
        tamil: "பண்டிட். தீண்டயால் உபாத்யாயா"
      },
      role: {
        english: "Ideological Guide",
        tamil: "சித்தாந்த வழிகாட்டி"
      },
      period: "2018",
      active: false,
      img: "/assets/images/5.jpeg"
    },
    {
      name: {
        english: "Atal Bihari Vajpayee",
        tamil: "அடல் பிஹாரி வாஜ்பாய்"
      },
      role: {
        english: "First BJP Prime Minister",
        tamil: "முதல் பாஜக பிரதமர்"
      },
      period: "2020",
      active: false,
      img: "/assets/images/10.jpeg"
    },
    {
      name: {
        english: "Narendra Modi",
        tamil: "நரேந்திர மோடி"
      },
      role: {
        english: "Prime Minister of India",
        tamil: "இந்திய பிரதமர்"
      },
      period: "2024",
      active: true,
      img: "/assets/images/11.jpeg"
    }
  ];

  const achievements = [
    {
      title: {
        english: "Women Empowerment Leadership",
        tamil: "பெண்கள் முன்னேற்ற தலைமைத்துவம்"
      },
      subtitle: {
        english: "Guided & Trained Women Groups",
        tamil: "பெண்கள் குழுக்களுக்கு வழிகாட்டல்"
      },
      img: "/assets/sudha-bjp/cup.png"
    },
    {
      title: {
        english: "Entrepreneurship Journey",
        tamil: "தொழில்முனைவோர் பயணம்"
      },
      subtitle: {
        english: "Founder – Sanjay Bankers",
        tamil: "சஞ்சய் பேங்கர்ஸ் நிறுவனர்"
      },
      img: "/assets/sudha-bjp/cup.png"
    },
    {
      title: {
        english: "Social Service Contribution",
        tamil: "சமூக சேவை பங்களிப்பு"
      },
      subtitle: {
        english: "Helped Over 1 Lakh People",
        tamil: "ஒரு இலட்சத்திற்கும் மேற்பட்டோருக்கு உதவி"
      },
      img: "/assets/sudha-bjp/cup.png"
    },
    {
      title: {
        english: "Healthcare & Nutrition Guidance",
        tamil: "ஆரோக்கிய மற்றும் ஊட்டச்சத்து வழிகாட்டல்"
      },
      subtitle: {
        english: "Counselling & Health Awareness",
        tamil: "ஆலோசனை & விழிப்புணர்வு"
      },
      img: "/assets/sudha-bjp/cup.png"
    },
    {
      title: {
        english: "GST Implementation",
        tamil: "ஜிஎஸ்டி நடைமுறைப்படுத்தல்"
      },
      subtitle: {
        english: "Economic Reform",
        tamil: "பொருளாதார சீர்திருத்தம்"
      },
      img: "/assets/sudha-bjp/cup.png"
    },
    {
      title: {
        english: "Digital India Mission",
        tamil: "டிஜிட்டல் இந்தியா திட்டம்"
      },
      subtitle: {
        english: "Technology Advancement",
        tamil: "தொழில்நுட்ப வளர்ச்சி"
      },
      img: "/assets/sudha-bjp/cup.png"
    },
    {
      title: {
        english: "Ayushman Bharat Scheme",
        tamil: "ஆயுஷ்மான் பாரத் திட்டம்"
      },
      subtitle: {
        english: "Healthcare Support",
        tamil: "மருத்துவ சேவை"
      },
      img: "/assets/sudha-bjp/cup.png"
    },
    {
      title: {
        english: "Make in India Initiative",
        tamil: "மேக் இன் இந்தியா முயற்சி"
      },
      subtitle: {
        english: "Manufacturing Growth",
        tamil: "உற்பத்தித் துறை வளர்ச்சி"
      },
      img: "/assets/sudha-bjp/cup.png"
    },
    {
      title: {
        english: "BJP Membership & Political Service",
        tamil: "BJP உறுப்பினர் & அரசியல் சேவை"
      },
      subtitle: {
        english: "Active Party Member for 10+ Years",
        tamil: "10 ஆண்டுகளுக்கும் மேலான செயல்பாடு"
      },
      img: "/assets/sudha-bjp/cup.png"
    }
  ];

  const data = [
    {
      year: "1980",
      title: {
        english: "Foundation",
        tamil: "அடிப்படை"
      },
      desc: {
        english: "BJP was formed on April 6, 1980.",
        tamil: "BJP ஏப்ரல் 6, 1980 அன்று உருவாக்கப்பட்டது."
      }
    },
    {
      year: "1984",
      title: {
        english: "First Election",
        tamil: "முதல் தேர்தல்"
      },
      desc: {
        english: "Won 2 seats in Lok Sabha elections.",
        tamil: "மக்களவைத் தேர்தலில் 2 இடங்களை வென்றது."
      }
    },
    {
      year: "1996",
      title: {
        english: "Single Largest Party",
        tamil: "ஒற்றை பெரிய கட்சி"
      },
      desc: {
        english: "Emerges as largest party, Vajpayee becomes PM for 13 days.",
        tamil: "பெரிய கட்சியாக உருவெடுத்தது, வாஜ்பாய் 13 நாட்களுக்கு பிரதமரானார்."
      }
    },
    {
      year: "1998",
      title: {
        english: "NDA Formation",
        tamil: "NDA உருவாக்கம்"
      },
      desc: {
        english: "Formed government under Vajpayee ji's leadership.",
        tamil: "வாஜ்பாய் தலைமையில் அரசாங்கம் உருவாக்கப்பட்டது."
      }
    },
    {
      year: "2014",
      title: {
        english: "Historic Mandate",
        tamil: "வரலாற்று ஆணை"
      },
      desc: {
        english: "Full majority under PM Narendra Modi.",
        tamil: "பிரதமர் நரேந்திர மோடி தலைமையில் முழு பெரும்பான்மை."
      }
    },
    {
      year: "2019",
      title: {
        english: "Re-election",
        tamil: "மீண்டும் தேர்ந்தெடுக்கப்பட்டது"
      },
      desc: {
        english: "Returned with an even bigger mandate of 303 seats.",
        tamil: "303 இடங்கள் என மேலும் பெரிய ஆணையுடன் திரும்பியது."
      }
    }
  ];

  return (
    <div>
      <section className="history-section">
        <h2>{content.historyTitle[language]}</h2>
        <p className="history-desc">
          {content.historyDescription[language]}
        </p>

        <div className="history-stats">
          {stats.map((item, index) => (
            <div className="stat" key={index}>
              <h3>{item.value}</h3>
              <span>{item.label[language]}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="about-highlight-section">
        <div className="about-highlight-container">
          {/* IMAGE */}
          <div className="about-image">
            <h2>{content.profileTitle[language]}</h2>
            <img
              src="/assets/sudha-bjp/abt.jpeg"
              alt="Profile Overview"
              loading="lazy"
            />
          </div>

          {/* CONTENT */}
          <div className="about-content">


            {(expanded
              ? highlightContent[language]
              : highlightContent[language].slice(0, 1)
            ).map((section, index) => (
              <div key={index} className="content-section">
                <h3>{section.heading}</h3>
                {section.content.map((text, i) => (
                  <p key={i}>{text}</p>
                ))}
              </div>
            ))}

            {/* ACTION BUTTONS */}
            <div className="about-actions">
              <button
                className="primary-btn"
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? content.readLess[language] : content.readMore[language]}
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="ideology-section">
        <h2>{content.ideologyTitle[language]}</h2>
        <div className="ideology-cards">
          {ideologyData.map((item, index) => (
            <div className="ideology-card" key={index}>
              <div className="book-icon"><img src="/assets/sudha-bjp/book.png" alt="" /></div>
              <h4>{item.title[language]}</h4>
              <p>{item.desc[language]}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="leadership-section">
        <h2>{content.leadershipTitle[language]}</h2>
        <div className="leader-cards">
          {leaders.map((leader, i) => (
            <div
              key={i}
              className={`leader-card1 ${leader.active ? "active" : ""}`}
            >
              <div className="leader-image">
                <img src={leader.img} alt="" />
              </div>
              <div className="leader-info">
                {/* <h4>{leader.name[language]}</h4>
                <span className="role">{leader.role[language]}</span> */}
                <span className="period">{leader.period}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="journey">
        <h2>{content.journeyTitle[language]}</h2>
        <div className="timeline">
          {data.map((item, index) => (
            <div className="timeline-item" key={index}>
              <div className={`content ${index % 2 === 0 ? "left" : "right"}`}>
                <h4>{item.title[language]}</h4>
                <p>{item.desc[language]}</p>
              </div>
              {/* YEAR — ALWAYS CENTER */}
              <div className="year">{item.year}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="achievement-section">
        <h2>{content.achievementsTitle[language]}</h2>
        <div className="achievement-grid">
          {achievements.map((item, i) => (
            <div className="achievement-card" key={i}>
              <div className="achievement-icon"><img src={item.img} alt="" /></div>
              <div className='achievement-text'>
                <h4>{item.title[language]}</h4>
                <span>{item.subtitle[language]}</span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default About